// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"632a4f51","107":"5a11a789","367":"a3b4d5ed","545":"81ce66e3","747":"1a94e988","836":"2f8d056e"}[chunkId] + ".chunk.css";
};